import React, { PureComponent } from "react"

import FormInput from "@/_components/FormInput"

class TextAreaEditor extends PureComponent {
  handleChange = patch => {
    this.props.onChange(patch.value)
  }

  render() {
    const { value } = this.props
    return <FormInput inArray type="textarea" obj={{ value }} field="value" onSetState={this.handleChange} />
  }
}

export default TextAreaEditor
